import { tab } from '@testing-library/user-event/dist/tab';
import { TabView, TabPanel } from 'primereact/tabview';
import ManageRemindersForm from './base/ManageRemindersForm';

import './ManageReminders.scss';

const tabs = [
  {
    header: 'Initial email',
    notificationType: 1,
  },
  {
    header: 'Approaching deadline notice',
    notificationType: 2,
  },
  {
    header: 'Reminder 1',
    notificationType: 3,
  },
  {
    header: 'Reminder 2',
    notificationType: 4,
  },
  {
    header: 'Reminder 3',
    notificationType: 5,
  },
  {
    header: 'Reminder 4',
    notificationType: 6,
  },
  {
    header: 'Reminder 5',
    notificationType: 7,
  },
  {
    header: 'Reminder 6',
    notificationType: 8,
  },
  {
    header: 'Reminder 7',
    notificationType: 9,
  },
];

const ManageRemainders = () => {
  return (
    <section className="manage-reminders">
      <TabView >
        {tabs.map(tab => {
          return (
            <TabPanel key={tab.notificationType} header={tab.header}>
              <ManageRemindersForm type={tab.notificationType} />
            </TabPanel>
          );
        })}
      </TabView>
    </section>
  );
};

export default ManageRemainders;
